import React from "react";
import { useStoreHook } from "../../store";

const Modal = () => {
  const modal = useStoreHook((state) => state.modal);

  const isSubmit = modal.onSubmit && modal.onSubmitText;
  const isClose = modal.onClose;

  return (
    <div className="modal-body">
      {modal.title && (
        <div className="modal-title-box">
          <div className="modal-title">{modal.title}</div>
        </div>
      )}

      {modal.content && <div className="modal-content">{modal.content}</div>}

      <div className="modal-actions">
        {isClose && (
          <button
            className="btn btn-close"
            type="button"
            onClick={() => {
              modal.closeModal();
              modal.onClose();
            }}
          >
            <span>Close</span>
          </button>
        )}

        {isSubmit && (
          <button
            className="btn btn-submit"
            type="button"
            onClick={() => {
              modal.closeModal();
              modal.onSubmit();
            }}
          >
            <span>{modal.onSubmitText}</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default Modal;
